
import React from "react";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { motion } from "framer-motion";

interface CommentaryResultProps {
  commentary: string;
}

const CommentaryResult: React.FC<CommentaryResultProps> = ({ commentary }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="bg-white border border-heaven-gold/10 shadow-md rounded-lg overflow-hidden mb-6">
        <div className="p-6">
          <h3 className="text-xl font-playfair font-semibold text-heaven-gold mb-4">
            Theological Commentary
          </h3>
          <Separator className="mb-4 bg-heaven-gold/10" />
          <div className="prose prose-heaven max-w-none">
            <div 
              className="text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: commentary.replace(/\n/g, '<br />') }}
            />
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default CommentaryResult;
